import projects from './projects';
import certificates from './certificates';
import blogPosts from './blogPosts';

export const SEARCH_CATEGORIES = {
  PROJECT: 'PROJECT',
  PAGE: 'PAGE',
  BLOG: 'BLOG',
  CERTIFICATE: 'CERTIFICATE',
  EXPERIENCE: 'EXPERIENCE',
  ACTIVITY: 'ACTIVITY',
  CONTACT: 'CONTACT',
  SOCIAL: 'SOCIAL',
  DOCUMENT: 'DOCUMENT'
};

const baseStaticItems = [
  // --- Core Pages & Blog ---
  {
    id: 'page-home',
    category: SEARCH_CATEGORIES.PAGE,
    title: 'Home / Ana Sayfa',
    subtitle: 'Melih Emik personal portfolio terminal',
    url: '/',
    isExternal: false,
    tags: ['home', 'main', 'start', 'anasayfa', 'terminal', 'cyberpunk', 'melih emik']
  },
  {
    id: 'page-blog',
    category: SEARCH_CATEGORIES.PAGE,
    title: 'Blog',
    subtitle: 'Articles, essays, and software engineering notes',
    url: '/blog',
    isExternal: false,
    tags: ['blog', 'articles', 'writeups', 'yazilar', 'yazılar', 'posts', 'thoughts', 'linux', 'rust', 'software']
  },
  {
    id: 'page-projects',
    category: SEARCH_CATEGORIES.PAGE,
    title: 'Projects / Projelerim',
    subtitle: 'Software, forensic tools, and digital platforms',
    url: '/projects',
    isExternal: false,
    tags: ['projects', 'projelerim', 'portfolio', 'apps', 'software', 'rust', 'tools', 'code']
  },
  {
    id: 'page-certificates',
    category: SEARCH_CATEGORIES.PAGE,
    title: 'Certificates / Sertifikalarım',
    subtitle: 'Security, Linux Foundation, Cisco, and BTK certifications',
    url: '/certificates',
    isExternal: false,
    tags: ['certificates', 'sertifikalarim', 'badges', 'linux foundation', 'cisco', 'btk', 'hackviser', 'anthropic']
  },
  {
    id: 'page-about',
    category: SEARCH_CATEGORIES.PAGE,
    title: 'About / Hakkımda',
    subtitle: 'Bio, experience, skills, GitHub activity, and PGP key',
    url: '/about',
    isExternal: false,
    tags: ['about', 'hakkimda', 'bio', 'skills', 'experience', 'whoami', 'developer', 'security']
  },
  {
    id: 'page-resume',
    category: SEARCH_CATEGORIES.PAGE,
    title: 'Resume / CV',
    subtitle: 'Interactive CV viewer, experiences, education, and PDF download',
    url: '/resume',
    isExternal: false,
    tags: ['resume', 'cv', 'curriculum vitae', 'ozgecmis', 'career', 'education', 'jobs', 'download']
  },

  // --- Document & CV ---
  {
    id: 'doc-resume-pdf',
    category: SEARCH_CATEGORIES.DOCUMENT,
    title: 'Download CV (PDF)',
    subtitle: 'Melih Emik - Official Curriculum Vitae / Resume PDF',
    url: '/melihemik.pdf',
    isExternal: true,
    tags: ['cv', 'resume', 'pdf', 'download', 'ozgecmis', 'melihemik.pdf', 'document']
  },

  // --- Sections in About ---
  {
    id: 'section-github-activity',
    category: SEARCH_CATEGORIES.ACTIVITY,
    title: 'GitHub Activity & Contributions',
    subtitle: '@melihemik contribution calendar and commit statistics',
    url: '/about#activity-title',
    isExternal: false,
    tags: ['github activity', 'activity', 'contributions', 'heatmap', 'calendar', '5338 contributions', 'commits', 'stats', 'yeşil tablo']
  },
  {
    id: 'section-linux-kernel',
    category: SEARCH_CATEGORIES.EXPERIENCE,
    title: 'Linux Kernel Contributor',
    subtitle: 'Kernel development & open source contribution (March 2026 - Present)',
    url: '/about#experience-title',
    isExternal: false,
    tags: ['linux', 'kernel', 'contributor', 'open source', 'c', 'driver', 'experience', 'experience-title']
  },
  {
    id: 'section-technoone',
    category: SEARCH_CATEGORIES.EXPERIENCE,
    title: 'TechnoOne - Software Intern',
    subtitle: 'Software engineering internship (July 2026 - August 2026)',
    url: '/about#experience-title',
    isExternal: false,
    tags: ['technoone', 'intern', 'software intern', 'staj', 'experience', 'company']
  },
  {
    id: 'section-skills',
    category: SEARCH_CATEGORIES.EXPERIENCE,
    title: 'Skills & Technologies',
    subtitle: 'Rust, Go, Python, C/C++, Linux, Docker, Digital Forensics, Pentest',
    url: '/about',
    isExternal: false,
    tags: ['skills', 'yetenekler', 'technologies', 'rust', 'go', 'python', 'c', 'c++', 'linux', 'docker', 'pentest', 'dfir', 'teknolojiler']
  },

  // --- Social & Contact ---
  {
    id: 'contact-email',
    category: SEARCH_CATEGORIES.CONTACT,
    title: 'Email: melihemik@noirlang.tr',
    subtitle: 'Official contact email address',
    url: 'mailto:melihemik@noirlang.tr',
    isExternal: true,
    tags: ['email', 'mail', 'contact', 'iletisim', 'melihemik@noirlang.tr', 'inbox']
  },
  {
    id: 'contact-pgp',
    category: SEARCH_CATEGORIES.CONTACT,
    title: 'PGP Public Key',
    subtitle: 'Fingerprint: DB00 D360 9762 7EDC AA5F 759C CF4D 46CF 340D 424F',
    url: 'https://keys.openpgp.org/search?q=melihemik@noirlang.tr',
    isExternal: true,
    tags: ['pgp', 'gpg', 'security', 'key', 'encryption', 'fingerprint', 'verify', 'openpgp']
  },
  {
    id: 'social-github',
    category: SEARCH_CATEGORIES.SOCIAL,
    title: 'GitHub Profile (@melihemik)',
    subtitle: 'Open source repositories, stars, and code activity',
    url: 'https://github.com/melihemik',
    isExternal: true,
    tags: ['github', 'profile', 'melihemik', 'code', 'git', 'repositories', 'open source']
  },
  {
    id: 'social-linkedin',
    category: SEARCH_CATEGORIES.SOCIAL,
    title: 'LinkedIn Profile',
    subtitle: 'Professional profile and network: /in/melihemik',
    url: 'https://linkedin.com/in/melihemik',
    isExternal: true,
    tags: ['linkedin', 'profile', 'network', 'career', 'job', 'social']
  },
  {
    id: 'social-instagram',
    category: SEARCH_CATEGORIES.SOCIAL,
    title: 'Instagram (@melihemik)',
    subtitle: 'Personal social profile',
    url: 'https://www.instagram.com/melihemik',
    isExternal: true,
    tags: ['instagram', 'social', 'photo', 'melihemik']
  }
];

// Helper to normalize Turkish characters for search matching
export const normalizeTurkish = (str) => {
  if (!str) return '';
  return str
    .toLowerCase()
    .replace(/ı/g, 'i')
    .replace(/ğ/g, 'g')
    .replace(/ü/g, 'u')
    .replace(/ş/g, 's')
    .replace(/ö/g, 'o')
    .replace(/ç/g, 'c')
    .replace(/[^a-z0-9\s]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
};

export const getDynamicSearchIndex = () => {
  // Dynamically map all projects from projects.js
  const dynamicProjectItems = (projects || []).flatMap(proj => {
    const items = [
      {
        id: `project-${proj.slug}`,
        category: SEARCH_CATEGORIES.PROJECT,
        title: proj.title,
        subtitle: proj.summary || proj.message,
        url: `/projects#${proj.slug}`,
        isExternal: false,
        tags: [
          'project',
          'proje',
          proj.title.toLowerCase(),
          proj.slug.toLowerCase(),
          ...(proj.technologies || []).map(t => t.toLowerCase()),
          ...(proj.highlights || []).map(h => h.toLowerCase()),
          ...(proj.details || []).map(d => d.toLowerCase())
        ]
      }
    ];

    if (proj.link && proj.link !== '#' && proj.link !== '/' && proj.status !== 'Soon') {
      items.push({
        id: `project-${proj.slug}-web`,
        category: SEARCH_CATEGORIES.PROJECT,
        title: `${proj.title} (Website)`,
        subtitle: `Open live website: ${proj.link}`,
        url: proj.link,
        isExternal: true,
        tags: ['website', 'live', 'site', 'web', proj.title.toLowerCase(), proj.slug.toLowerCase(), proj.link.toLowerCase()]
      });
    }

    if (proj.github) {
      items.push({
        id: `project-${proj.slug}-github`,
        category: SEARCH_CATEGORIES.PROJECT,
        title: `${proj.title} (GitHub)`,
        subtitle: `View repository on GitHub: ${proj.github}`,
        url: proj.github,
        isExternal: true,
        tags: ['github', 'repo', 'repository', 'source', 'code', proj.title.toLowerCase(), proj.slug.toLowerCase(), proj.github.toLowerCase()]
      });
    }

    return items;
  });

  // Dynamically map all certificates from certificates.js
  const dynamicCertItems = (certificates || []).map((cert, index) => ({
    id: `cert-${index}`,
    category: SEARCH_CATEGORIES.CERTIFICATE,
    title: cert.title,
    subtitle: `${cert.issuer} • ${cert.date}${cert.credentialId ? ` • ID: ${cert.credentialId}` : ''}`,
    url: cert.link || '/certificates',
    isExternal: !!cert.link,
    tags: [
      'certificate',
      'sertifika',
      'rozet',
      'badge',
      cert.title.toLowerCase(),
      cert.issuer.toLowerCase(),
      cert.date.toLowerCase(),
      (cert.credentialId || '').toLowerCase()
    ]
  }));

  const dynamicBlogItems = blogPosts.map(post => ({
    id: `blog-${post.slug}`,
    category: SEARCH_CATEGORIES.BLOG,
    title: post.title,
    subtitle: `${post.date} — ${post.summary}`,
    url: `/blog/${post.slug}`,
    isExternal: false,
    tags: [
      'blog',
      'article',
      'yazi',
      'yazı',
      post.slug,
      ...post.tags.map(t => t.toLowerCase())
    ]
  }));

  return [
    ...baseStaticItems,
    ...dynamicProjectItems,
    ...dynamicCertItems,
    ...dynamicBlogItems
  ];
};

export const searchSite = (query) => {
  const index = getDynamicSearchIndex();

  if (!query || !query.trim()) {
    return index.slice(0, 12);
  }

  const rawQuery = query.trim().toLowerCase();
  const normQuery = normalizeTurkish(query);
  const queryTerms = normQuery.split(' ').filter(Boolean);

  const scored = index.map(item => {
    let score = 0;
    const titleLower = item.title.toLowerCase();
    const titleNorm = normalizeTurkish(item.title);
    const subNorm = normalizeTurkish(item.subtitle);
    const urlLower = item.url.toLowerCase();
    const tagsNorm = normalizeTurkish(item.tags.join(' '));

    // Exact full match
    if (titleLower === rawQuery || titleNorm === normQuery) {
      score += 150;
    } else if (titleNorm.startsWith(normQuery)) {
      score += 80;
    } else if (titleNorm.includes(normQuery)) {
      score += 45;
    }

    if (subNorm.includes(normQuery)) {
      score += 25;
    }

    if (tagsNorm.includes(normQuery)) {
      score += 20;
    }

    if (urlLower.includes(rawQuery)) {
      score += 15;
    }

    // Term-based fuzzy match
    for (const term of queryTerms) {
      if (titleNorm.includes(term)) score += 20;
      if (subNorm.includes(term)) score += 10;
      if (tagsNorm.includes(term)) score += 8;
      if (urlLower.includes(term)) score += 5;
    }

    return { item, score };
  });

  return scored
    .filter(res => res.score > 0)
    .sort((a, b) => b.score - a.score)
    .map(res => res.item);
};
